import { APIClient } from "api/api_helper";
import { SUBJECT_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

/* ------------------------------------------------------------------
 * LABEL API
 * ------------------------------------------------------------------ */

export const SubjectLabelApiService = {
    // UPDATE LABEL PRINT METHOD
    updateLabelPrint: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studyid: payload_data.studyid,
            volunteerassignment: payload_data.volunteerassignment || [],
            printtype: payload_data.printtype,
            printby: user?.userid,
            updatedby: user?.userid,
        };
        return api.create(SUBJECT_LABEL_API.SUBJECT_LABEL_API + "Update", payload);
    },
    // INSERT REPRINT HISTORY METHOD
    insertHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            createdby: user?.userid,
            reasonforreprint: payload_data.reasonforreprint,
            additionalcomments: payload_data.additionalcomments || null,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(SUBJECT_LABEL_API.SUBJECT_LABEL_HISTORY_API + "Insert", payload);
    },
};